import api from 'Plugins/api'
import HotelNeedOrder from '../entities/hotelNeedOrder'

class HotelNeedOrderInteractor {
  /**
   * 获取国际酒店需求单列表
   */
  static async getHotelNeedOrderList(query) {
    try {
      const { data = {} } = await api['htQuery/hotelNeedOrderList'](query)
      const list = data.list || []
      
      return {
        data: list.map(order => new HotelNeedOrder(order))
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 根据酒店询价单Id获取询价单`信息`
   */
  static async getHotelNeedOrderById(id) {
    try {
      const { data = {} } = await api['htQuery/getHtNeedOrderDetail']({
        id: id
      })
      
      return {
        data: new HotelNeedOrder(data)
      }
    } catch (error) {
      throw error
    }
  }
  
  /**
   * 根据酒店询价单Id查找询价单的`留言内容`
   */
  static async getHotelNeedNoteById(id) {
    try {
      const { data = [] } = await api['htQuery/findHtNeedNote']({
        orderId: id
      })
      
      return {
        data: data.sort((a, b) => a.noteDate - b.noteDate)
      }
    } catch (error) {
      throw error
    }
  }

  /**
   * 根据酒店询价单Id保存询价单的`留言内容`
   */
  static async updateHotelNeedNoteById(payload) {
    try {
      const data = await api['htQuery/savehtNeedNote'](payload)
      
      return data
    } catch (error) {
      throw error
    }
  }

}

export default HotelNeedOrderInteractor